export const pathnames = {
  HOME: '/',
  EXTERNAL_LOGIN: '/externalLogin',
  ORDER_INVOICE: '/orderInvoice',
  INVOICE_ORDERS: '/invoiceOrders',
  PAYMENT: '/payment',
  PAYMENT_ID: '/payment/:invoiceOrderID',
  INVITE_FRIEND: '/inviteFriend',
  INVOICES: '/invoices',
  RECEIPTS: '/receipts',
  SETTINGS: '/settings',
  CALCULATOR: '/calculator',
  TRANSFERS: '/transfers',
  REG_FORMS: '/regForms',
  AUTH: '/auth',
  LOGOUT: '/logout',
  GO_TO_FORM101: '/goToRegistrationForm101',
  LOGIN: '/login',
  LOGIN_BY_PHONE: '/loginByPhone',
  EXTERNAL_ADMIN_LOGIN: '/adminLogin',
  LOGIN_AS_ADMIN: '/loginAsAdmin',
  FORGOT_PASSWORD: '/forgotPassword',
  UPDATE_PASSWORD: '/updatePassword',
  REGISTER: '/register',
  PAYPAL_PAYMENT_STATUS: '/paypalPaymentStatus/:paypalID/:status'
};
